import React, { useState, useEffect } from "react";

import useBrowserMode from "../../../shared/hooks/useBrowserMode";
import { formatImageAlt, findRel } from "../../../shared/utils/stringUtilities";

import "./cardTopFive.scss";

interface CardTopFiveInter {
  conversation: any;
  number: any;
  sliderIdx?: any;
}

const CardTopFive = (props: CardTopFiveInter) => {
  const { conversation, number } = props;

  const { window } = useBrowserMode();
  const [onFocus, setOnFocus] = useState<string>("");
  const [onFocusDesc, setOnFocusDesc] = useState<string>("");
  const [innerWidth, setInnerWidth] = useState<any>(window.innerWidth);

  const handleMouseLeave = () => {
    setOnFocus("");
    setOnFocusDesc("");
  };

  if (innerWidth <= 960 && number === props.sliderIdx) {
    setOnFocus("on-focus");
    setOnFocusDesc("on-focus-description");
  }

  useEffect(() => {
    window.addEventListener("resize", () => setInnerWidth(window.innerWidth));
  });

  return (
    <a
      className={`a-card-top-five ${onFocus}`}
      id={`top-${number}`}
      onMouseEnter={() => {
        setOnFocus("on-focus");
        setOnFocusDesc("on-focus-description");
      }}
      onMouseLeave={handleMouseLeave}
      href={conversation.redireccionBoton}
      rel={findRel(conversation.redireccionBoton)}
    >
      <img src={conversation.imagenPrincipal[0].file.url} alt={formatImageAlt(conversation.imagenPrincipal[0].title)} />
      <p className="a-card-top-five__number">{number}</p>
      <p
        className={`a-card-top-five__description ${onFocusDesc}`}
        id={`top-description-${number}`}
      >
        {conversation.descripcion.json.content[0].content[0].value}
      </p>
      <p className="a-card-top-five__comments">+ {conversation.comments}</p>
    </a>
  );
};

export default CardTopFive;
